// 职业规划相关接口
import request from './request'

/**
 * 创建会话
 * @param {Object} data - 请求数据
 * @param {string} data.resumeUrl - 简历 URL
 * @param {string} data.mbtiType - MBTI 类型
 * @returns {Promise} 返回 sessionId
 */
export function newSession(data) {
  return request({
    url: '/api/careerPlan/session/new',
    method: 'post',
    data
  })
}

/**
 * 获取会话详情（历史对话）
 * @param {string|number} sessionId - 会话 ID
 * @returns {Promise} 返回会话详情
 */
export function getSessionDetail(sessionId) {
  return request({
    url: `/api/careerPlan/session/${sessionId}/detail`,
    method: 'get'
  })
}

/**
 * 获取会话列表
 * @param {Object} params - 查询参数
 * @param {boolean} params.favoriteOnly - 是否只获取收藏的会话
 * @param {number} params.page - 页码，从1开始
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise} 返回会话列表
 */
export function getSessionList(params = {}) {
  return request({
    url: '/api/careerPlan/session/list',
    method: 'get',
    params
  })
}

export function favoriteSession(sessionId, data) {
  return request({
    url: `/api/careerPlan/session/${sessionId}/favorite`,
    method: 'put',
    data
  })
}

/**
 * 获取会话的历史消息
 * @param {Object} params
 * @param {string|number} params.sessionId - 会话 ID
 * @returns {Promise} 返回消息列表
 */
export function getSessionMessages(sessionId, params = {}) {
  return request({
    url: `/api/careerPlan/session/${sessionId}/messages`,
    method: 'get',
    params
  })
}

/**
 * 创建一个新的会话（有历史记录时点击"新对话"使用，或没有历史记录时上传简历后使用）
 * @param {Object} data - 请求数据（可选）
 * @param {string} data.resumeUrl - 简历 URL（可选）
 * @param {string} data.mbtiType - MBTI 类型（可选）
 * @returns {Promise} 返回新会话信息（含 sessionId）
 */
export function createSession(data = {}) {
  return request({
    url: '/api/careerPlan/session/create',
    method: 'post',
    data
  })
}

/**
 * 更新会话信息
 * @param {string|number} sessionId - 会话 ID
 * @param {Object} data - 要更新的数据
 * @param {string} data.resumeUrl - 简历 URL（可选）
 * @param {string} data.mbtiType - MBTI 类型（可选）
 * @returns {Promise} 返回更新后的会话信息
 */
export function updateSession(sessionId, data = {}) {
  return request({
    url: `/api/careerPlan/session/${sessionId}`,
    method: 'put',
    data
  })
}


